export default "__VITE_ASSET__4913dff1__"